import { useEffect, useState, useRef } from 'react'
import { seatBeltLeft, seatBeltRight } from '@/assets/images'
import { loadAudioBuffer, playAudioBuffer } from '@/lib/sounds'

const INITIAL_WAIT = 500
const ANIMATION_DURATION = 3500
const WAIT_AFTER_ANIMATION = 2000
const TOTAL_DURATION = INITIAL_WAIT + ANIMATION_DURATION + WAIT_AFTER_ANIMATION

export function SeatbeltAnimation({ onComplete, shouldAnimate = false }) {
  const [phase, setPhase] = useState('waiting')
  const audioBufferRef = useRef(null)

  useEffect(() => {
    loadAudioBuffer('/sounds/Aviation_Seat_Belt_Chime.wav').then(buffer => {
      audioBufferRef.current = buffer
    })
  }, [])

  useEffect(() => {
    if (!shouldAnimate) {
      setPhase('waiting')
      return
    }

    const timers = [
      setTimeout(() => setPhase('animating'), INITIAL_WAIT),
      setTimeout(() => {
        setPhase('completed')
        if (audioBufferRef.current) {
          playAudioBuffer(audioBufferRef.current, 1.0)// volume 100%
        }
      }, INITIAL_WAIT + ANIMATION_DURATION),
      setTimeout(() => onComplete?.(), TOTAL_DURATION),
    ]
    return () => timers.forEach(clearTimeout)
  }, [shouldAnimate, onComplete])

  return (
    <>
      <style>{`
        @keyframes slideLeftBelt {
          from {
            transform: translateX(-20%);
          }
          to {
            transform: translateX(calc(0% - 3px));
          }
        }

        @keyframes slideRightBelt {
          from {
            transform: translateX(20%);
          }
          to {
            transform: translateX(calc(0% + 3px));
          }
        }

        @keyframes slideLeftBeltMobile {
          from {
            transform: translateX(-20%);
          }
          to {
            transform: translateX(calc(0% - 15px));
          }
        }

        @keyframes slideRightBeltMobile {
          from {
            transform: translateX(20%);
          }
          to {
            transform: translateX(calc(0% + 15px));
          }
        }

        @keyframes turnGreen {
          from {
            filter: none;
          }
          to {
            filter: brightness(0) saturate(100%) invert(69%) sepia(56%) saturate(3283%) hue-rotate(101deg) brightness(101%) contrast(86%);
          }
        }

        .belt-left {
          left: -4%;
          transform: translateX(-20%);
        }

        .belt-right {
          right: -4%;
          transform: translateX(20%);
        }

        .belt-left-animation {
          left: -4%;
          transform: translateX(-20%);
          animation: slideLeftBelt 3s cubic-bezier(0.33, 1, 0.68, 1) forwards,
                     turnGreen 0.3s ease-in forwards;
          animation-delay: 1s, 1s;
        }

        .belt-right-animation {
          right: -4%;
          transform: translateX(20%);
          animation: slideRightBelt 3s cubic-bezier(0.33, 1, 0.68, 1) forwards,
                     turnGreen 0.3s ease-in forwards;
          animation-delay: 1s, 1s;
        }

        @media (max-width: 370px) {
          .belt-left-animation {
            animation-name: slideLeftBeltMobile, turnGreen;
          }

          .belt-right-animation {
            animation-name: slideRightBeltMobile, turnGreen;
          }
        }
      `}</style>
      <div className="space-y-1 py-1 mb-2">
        
        <div className="relative w-full h-16 flex items-center justify-center overflow-hidden -mb-2">
          <img
            src={seatBeltLeft}
            alt=""
            className={`absolute h-8 z-20 ${shouldAnimate ? 'belt-left-animation' : 'belt-left'}`}
          />
          <img
            src={seatBeltRight}
            alt=""
            className={`absolute h-8 z-10 ${shouldAnimate ? 'belt-right-animation' : 'belt-right'}`}
          />
        </div>

        <div className="text-center">
          {phase === 'waiting' && !shouldAnimate ? (
            <p className="text-sm font-semibold text-[#71717A]">Publish your changes</p>
          ) : phase === 'waiting' || phase === 'animating' ? (
            <p className="text-sm font-semibold text-[#71717A]">Checking for publishing errors...</p>
          ) : (
            <p className="text-sm font-semibold text-[#71717A]">Your project is ready to go live!</p>
          )}
        </div>
      </div>
    </>
  )
}

